// extracted by mini-css-extract-plugin
export default {"App":"App_App__oR6oM","App-logo":"App_App-logo__KiAB8","App-logo-spin":"App_App-logo-spin__np5Xx","App-header":"App_App-header__6d0WW","App-link":"App_App-link__-ZL3z"};